import { render, staticRenderFns } from "./SalaryEdit.vue?vue&type=template&id=7c2f787c&"
import script from "./SalaryEdit.vue?vue&type=script&lang=js&"
export * from "./SalaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports